import { isClinicalBookingStateSupported } from "./clinicalBookingStates.mjs";
import { z as z$1 } from "zod";

// src/models/consultation/clinicalInsuranceCategory.ts
const clinicalInsuranceCategorySchema = z$1.enum([
	"private_employer",
	"medicare_advantage",
	"original_medicare",
	"medicaid",
	"government_employer",
	"other_insurance",
	"no_insurance"
]);
const clinicalConsultationInterestSchema = z$1.enum(["yes", "no"]);
const CLINICAL_INSURANCE_CATEGORY_OPTIONS = [
	{
		id: "private_employer",
		label: "Plan through private employer"
	},
	{
		id: "medicare_advantage",
		label: "Medicare Advantage"
	},
	{
		id: "original_medicare",
		label: "Original Medicare (Part A/B)"
	},
	{
		id: "medicaid",
		label: "Medicaid"
	},
	{
		id: "government_employer",
		label: "Plan through government employer (for example VA)"
	},
	{
		id: "other_insurance",
		label: "Different category of insurance"
	},
	{
		id: "no_insurance",
		label: "Do not currently have health insurance"
	}
];
/** Four options shown in the clinical booking insurance category step (screen 04). */
const CLINICAL_BOOKING_INSURANCE_CATEGORY_UI_OPTIONS = [
	{
		id: "private_employer",
		label: "Plan through private company employer"
	},
	{
		id: "medicare_advantage",
		label: "Medicare Advantage"
	},
	{
		id: "other_insurance",
		label: "A different type of insurance"
	},
	{
		id: "no_insurance",
		label: "I don't currently have health insurance"
	}
];
const INSURANCE_ELIGIBLE_CATEGORIES = ["private_employer", "medicare_advantage"];
function isInsuranceEligibleClinicalCategory(category) {
	if (!category) return false;
	return INSURANCE_ELIGIBLE_CATEGORIES.includes(category);
}
/** Maps signup insurance category to clinical billing path (no Bridge). */
function insuranceCategoryBillingPath(category) {
	if (!category) return null;
	return isInsuranceEligibleClinicalCategory(category) ? "insured" : "self_pay";
}
/** Signup clinical consultation eligibility (licensed state + category; no Bridge). */
function resolveSignupClinicalConsultationEligibility(args) {
	if (!isClinicalBookingStateSupported(args.stateOfResidence, args.supportedStateCodes)) return "community_only";
	if (isInsuranceEligibleClinicalCategory(args.insuranceCategory)) return "insurance_eligible";
	return "cash_pay_eligible";
}
function isSignupClinicalConsultationOffered(eligibility) {
	return eligibility === "insurance_eligible" || eligibility === "cash_pay_eligible";
}

export { CLINICAL_BOOKING_INSURANCE_CATEGORY_UI_OPTIONS, CLINICAL_INSURANCE_CATEGORY_OPTIONS, clinicalConsultationInterestSchema, clinicalInsuranceCategorySchema, insuranceCategoryBillingPath, isInsuranceEligibleClinicalCategory, isSignupClinicalConsultationOffered, resolveSignupClinicalConsultationEligibility };
//# sourceMappingURL=clinicalInsuranceCategory.mjs.map